import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Tag } from '@repo/design-system/components/ui/tag';
import { Type } from '@repo/design-system/components/ui/type';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectIsCompactViewport } from '@repo/store/maps/slices/clientContext';
interface ChecklistEntryButtonProps {
  onClick: () => void;
}
export const ChecklistEntryButton = t0 => {
  const $0 = _c(23);
  const {
    onClick
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useT(t1);
  const isCompactViewport = useAppSelector(selectIsCompactViewport);
  let t2;
  if ($0[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = css({
      borderRadius: "8",
      width: "full",
      padding: "6",
      cursor: "pointer",
      transition: "[background-color 0.2s ease-in-out]",
      _hover: {
        backgroundColor: "whiteAlpha.10"
      }
    });
    $0[1] = t2;
  } else {
    t2 = $0[1];
  }
  let t3;
  if ($0[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon icon="checklist" size="md" className={css({
      color: "text.secondary",
      width: "[20px]",
      height: "[20px]",
      flexShrink: "0"
    })} decorative={true} />;
    $0[2] = t3;
  } else {
    t3 = $0[2];
  }
  let t4;
  if ($0[3] !== isCompactViewport) {
    t4 = $ => isCompactViewport ? $.checklist_pages.checklist_title_short : $.checklist_pages.checklist_title;
    $0[3] = isCompactViewport;
    $0[4] = t4;
  } else {
    t4 = $0[4];
  }
  let t5;
  if ($0[5] !== t || $0[6] !== t4) {
    t5 = t(t4);
    $0[5] = t;
    $0[6] = t4;
    $0[7] = t5;
  } else {
    t5 = $0[7];
  }
  let t6;
  if ($0[8] !== t5) {
    t6 = <Type variant="body-s">{t5}</Type>;
    $0[8] = t5;
    $0[9] = t6;
  } else {
    t6 = $0[9];
  }
  let t7;
  if ($0[10] !== t) {
    t7 = t(_temp);
    $0[10] = t;
    $0[11] = t7;
  } else {
    t7 = $0[11];
  }
  let t8;
  if ($0[12] !== t7) {
    t8 = <Tag variant="ghost">{t7}</Tag>;
    $0[12] = t7;
    $0[13] = t8;
  } else {
    t8 = $0[13];
  }
  let t9;
  if ($0[14] !== t6 || $0[15] !== t8) {
    t9 = <FlexColumn width="full"><FlexRow align="center" gap="12">{t6}{t8}</FlexRow></FlexColumn>;
    $0[14] = t6;
    $0[15] = t8;
    $0[16] = t9;
  } else {
    t9 = $0[16];
  }
  let t10;
  if ($0[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Icon icon="chevron_right" size="lg" decorative={true} className={css({
      color: "text.secondary"
    })} />;
    $0[17] = t10;
  } else {
    t10 = $0[17];
  }
  let t11;
  if ($0[18] !== t9) {
    t11 = <FlexRow gap="12" align="center" justify="between" width="full">{t3}{t9}{t10}</FlexRow>;
    $0[18] = t9;
    $0[19] = t11;
  } else {
    t11 = $0[19];
  }
  let t12;
  if ($0[20] !== onClick || $0[21] !== t11) {
    t12 = <Button variant="ghost" onClick={onClick} color="secondary" fullWidth={true} className={t2}>{t11}</Button>;
    $0[20] = onClick;
    $0[21] = t11;
    $0[22] = t12;
  } else {
    t12 = $0[22];
  }
  return t12;
};
function _temp($_0) {
  return $_0.session_history.new_badge;
}